import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { cognitoAuthHandler } from '../config/cognitoAuthHandler';
import { STAGES } from '../constants/urlConstants';
import { getEnvironmentStage } from '../util/envUtils';
import { useUserInfo } from './useUserInfo';

export const useCognitoAuth = () => {
  const dispatch = useDispatch();
  const userInfo = useUserInfo();

  let cognitoAuthorizer = {};
  const stage = getEnvironmentStage();

  useEffect(
    () => {
      if (stage !== STAGES.UNKNOWN_STAGE) {
        cognitoAuthHandler(stage, userInfo, dispatch);
      }
    },
    [stage],
  );

  return cognitoAuthorizer;
};
